import { render, staticRenderFns } from "./branch-company.vue?vue&type=template&id=074cd59e&"
import script from "./branch-company.vue?vue&type=script&lang=js&"
export * from "./branch-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports